
<div class="light_arousol_outer" *ngIf="storyPreviewForLight.length>0">
	<h1 class="heading">
		ALL {{storyPreviewForLight[0].storyContentCategory.storyContentType}}
	</h1>
	<div class="page-container for_home_slider">
		<div class="carousel_container single_carousol light_arousol">
			<owl-carousel-o [options]="customOptions">

					<ng-container *ngFor="let story of storyPreviewForLight; let i = index">
						<ng-container *ngIf="5>i">
							<ng-template carouselSlide>
								<div class="swiper-slide-container">
									<div class="slide_individual_home_banner">
										<!-- <div class="carousel_container_inner reflect">  for reflection-->
										<div class="carousel_container_inner">
											<div class="text_container">
												<h2>
													<span>{{story.title}}</span>
													<img class="motif" src="./assets/img/homepage_white_sec.svg"
														 alt="homepage white section motif">
												</h2>
												<p [innerHTML]="story.description | truncketHtml:250"></p>
												<button class="animate_icon_button">
													<i class="animate"><b></b><span></span></i>
													<a href="story-details/{{story.slug}}/{{story.id}}">
														<span class="text_animate_button"
															  >Discover More</span>
													</a>
												</button>
											</div>
											<div class="image_container">
												<div class="image_overlay"></div>
												<!--                                        <img class="desktop_image"-->
												<!--                                             src="{{story.bannerImageDesktop}}" alt="{{story.title}}"/>-->
												<div class="desktop_image_viewer"
													 [ngStyle]="{'background': 'url(' + story.bannerImageDesktop + ') ' +
				                                              'no-repeat 0 0 / cover'}">
												</div>
												<img class="mobile_image"
													 src="{{story.bannerImageMobile}}" alt="{{story.title}}"/>
											</div>
										</div>
									</div>
								</div>
							</ng-template>
						</ng-container>
					</ng-container>
			</owl-carousel-o>
		</div>
	</div>
</div>
